// Ids for lazy loaded redux modules
export const ReduxModuleIds = {
  employees: 'employees',
  admin: 'admin',
  panelet: 'panelet',
};
